module.exports = __webpack_public_path__ + "img/HA1510-01.665f52e5.jpg";